import { EventCatalogFromKeys, EventType } from "../types";

export const FormsEventKeys = {
  ACTIONS_DROPDOWN_ACTION_SELECT: "actions-dropdown-action-select",
  AREA_DISCOVERY_LINK_CLICK: "area-discovery-link-click",
  AREA_SELECTOR_CLEAR: "area-selector-clear",
  AREA_SELECTOR_DESELECT: "area-selector-deselect",
  AREA_SELECTOR_DESELECT_STATE: "area-selector-deselect-state",
  AREA_SELECTOR_SEARCH: "area-selector-search",
  AREA_SELECTOR_SELECT: "area-selector-select",
  AREA_SELECTOR_SELECT_ALL: "area-selector-select-all",
  AREA_SELECTOR_SELECT_STATE: "area-selector-select-state",
  AREAS_CLEAR_SEARCH: "areas-clear-search",
  AREAS_CLEAR_STATE: "areas-clear-state",
  AREAS_FILTER_STATE: "areas-filter-state",
  AREAS_SEARCH: "areas-search",
  AREAS_SORT: "areas-sort",
  AUTO_AREA_FILTER_APPLY: "auto-area-filter-apply",
  AUTO_AREA_FILTER_CLEAR: "auto-area-filter-clear",
  AUTO_AREA_FILTER_DISMISS: "auto-area-filter-dismiss",
  CLAIM_DETAILS_BACK_TO_NEEDS_CLICK: "claim-details-back-to-needs-click",
  CLAIM_DETAILS_CONTACT_CASEWORKER_CLICK:
    "claim-details-contact-caseworker-click",
  CLEAR_FILTERS_BUTTON_CLICK: "clear-filters-button-click",
  DELETE_AREA_ATTEMPT: "delete-area-attempt",
  DELETE_AREA_CANCEL: "delete-area-cancel",
  DELETE_AREA_FAILURE: "delete-area-failure",
  DELETE_AREA_MODAL_OPEN: "delete-area-modal-open",
  DELETE_AREA_SUCCESS: "delete-area-success",
  DELETE_CATEGORY_ATTEMPT: "delete-category-attempt",
  DELETE_CATEGORY_FAILURE: "delete-category-failure",
  DELETE_CATEGORY_SUCCESS: "delete-category-success",
  EMPTY_STATE_ACTION_BUTTON_CLICK: "empty-state-action-button-click",
  ERROR_CARD_BROWSE_OTHER_NEEDS_CLICK: "error-card-browse-other-needs-click",
  PURCHASE_LINKS_ADD: "purchase-links-add",
  PURCHASE_LINKS_REMOVE: "purchase-links-remove",
  SERVICE_AREA_CLEAR_STATE: "service-area-clear-state",
  SERVICE_AREA_DESELECT: "service-area-deselect",
  SERVICE_AREA_DESELECT_STATE: "service-area-deselect-state",
  SERVICE_AREA_SEARCH: "service-area-search",
  SERVICE_AREA_SELECT: "service-area-select",
  SERVICE_AREA_SELECT_STATE: "service-area-select-state",
  SETTINGS_COMPLETION_TRACKER_ITEM_CLICK:
    "settings-completion-tracker-item-click",
  STOCK_PHOTO_MODAL_CATEGORY_SELECT: "stock-photo-modal-category-select",
  STOCK_PHOTO_MODAL_CLOSE: "stock-photo-modal-close",
  STOCK_PHOTO_MODAL_CONFIRM: "stock-photo-modal-confirm",
  STOCK_PHOTO_MODAL_PHOTO_SELECT: "stock-photo-modal-photo-select",
  TAG_SELECTOR_CLEAR: "tag-selector-clear",
  TAG_SELECTOR_DESELECT: "tag-selector-deselect",
  TAG_SELECTOR_SEARCH: "tag-selector-search",
  TAG_SELECTOR_SELECT: "tag-selector-select",
  TAG_SELECTOR_SELECT_ALL_ACTIVE: "tag-selector-select-all-active",
  TUTORIAL_ERROR_BOUNDARY_ERROR: "tutorial-error-boundary-error",
  TUTORIAL_LAUNCHER_CLOSE: "tutorial-launcher-close",
  TUTORIAL_LAUNCHER_OPEN: "tutorial-launcher-open",
  TUTORIAL_LAUNCHER_START: "tutorial-launcher-start",
  TUTORIAL_OVERLAY_COMPLETE_STEP: "tutorial-overlay-complete-step",
  TUTORIAL_OVERLAY_FINISH: "tutorial-overlay-finish",
  TUTORIAL_OVERLAY_NEXT_STEP: "tutorial-overlay-next-step",
  TUTORIAL_OVERLAY_PREVIOUS_STEP: "tutorial-overlay-previous-step",
  TUTORIAL_OVERLAY_SKIP: "tutorial-overlay-skip",
  TUTORIAL_PROVIDER_COMPLETE: "tutorial-provider-complete",
  TUTORIAL_PROVIDER_ERROR: "tutorial-provider-error",
  TUTORIAL_PROVIDER_SKIP: "tutorial-provider-skip",
  TUTORIAL_PROVIDER_START: "tutorial-provider-start",
  VOLUNTEER_ENGAGEMENT_EXPORT: "volunteer-engagement-export",
  VOLUNTEER_ENGAGEMENT_REFRESH: "volunteer-engagement-refresh",
  VOLUNTEER_SIGNUP_OFFER_DECLINE_CLICK: "volunteer-signup-offer-decline-click",
  VOLUNTEER_SIGNUP_OFFER_SIGNUP_CLICK: "volunteer-signup-offer-signup-click",
} as const;

export const FormsEventCatalog: EventCatalogFromKeys<typeof FormsEventKeys> = {
  [FormsEventKeys.AREA_SELECTOR_SELECT]: {
    description: "User selected an area in AreaSelector",
    eventType: EventType.INTERACTION,
    id: FormsEventKeys.AREA_SELECTOR_SELECT,
  },
  [FormsEventKeys.AREA_SELECTOR_DESELECT]: {
    description: "User deselected an area in AreaSelector",
    eventType: EventType.INTERACTION,
    id: FormsEventKeys.AREA_SELECTOR_DESELECT,
  },
  [FormsEventKeys.AREA_SELECTOR_SELECT_ALL]: {
    description: "User selected all areas in AreaSelector",
    eventType: EventType.INTERACTION,
    id: FormsEventKeys.AREA_SELECTOR_SELECT_ALL,
  },
  [FormsEventKeys.AREA_SELECTOR_SELECT_STATE]: {
    description: "User selected all areas in a state in AreaSelector",
    eventType: EventType.INTERACTION,
    id: FormsEventKeys.AREA_SELECTOR_SELECT_STATE,
  },
  [FormsEventKeys.AREA_SELECTOR_DESELECT_STATE]: {
    description: "User deselected all areas in a state in AreaSelector",
    eventType: EventType.INTERACTION,
    id: FormsEventKeys.AREA_SELECTOR_DESELECT_STATE,
  },
  [FormsEventKeys.AREA_SELECTOR_CLEAR]: {
    description: "User cleared all area selections in AreaSelector",
    eventType: EventType.INTERACTION,
    id: FormsEventKeys.AREA_SELECTOR_CLEAR,
  },
  [FormsEventKeys.AREA_SELECTOR_SEARCH]: {
    description: "User searched for areas in AreaSelector",
    eventType: EventType.FILTER,
    id: FormsEventKeys.AREA_SELECTOR_SEARCH,
  },
  [FormsEventKeys.AREA_DISCOVERY_LINK_CLICK]: {
    description: "User clicked the area discovery link",
    eventType: EventType.BUTTON_CLICK,
    id: FormsEventKeys.AREA_DISCOVERY_LINK_CLICK,
  },
  [FormsEventKeys.AREAS_SEARCH]: {
    description: "User searched for areas",
    eventType: EventType.FILTER,
    id: FormsEventKeys.AREAS_SEARCH,
  },
  [FormsEventKeys.AREAS_CLEAR_SEARCH]: {
    description: "User cleared the areas search",
    eventType: EventType.INTERACTION,
    id: FormsEventKeys.AREAS_CLEAR_SEARCH,
  },
  [FormsEventKeys.AREAS_FILTER_STATE]: {
    description: "User filtered areas by state",
    eventType: EventType.FILTER,
    id: FormsEventKeys.AREAS_FILTER_STATE,
  },
  [FormsEventKeys.AREAS_CLEAR_STATE]: {
    description: "User cleared the state filter for areas",
    eventType: EventType.INTERACTION,
    id: FormsEventKeys.AREAS_CLEAR_STATE,
  },
  [FormsEventKeys.AREAS_SORT]: {
    description: "User sorted areas",
    eventType: EventType.INTERACTION,
    id: FormsEventKeys.AREAS_SORT,
  },
  [FormsEventKeys.AUTO_AREA_FILTER_APPLY]: {
    description: "User applied auto area filter",
    eventType: EventType.INTERACTION,
    id: FormsEventKeys.AUTO_AREA_FILTER_APPLY,
  },
  [FormsEventKeys.AUTO_AREA_FILTER_CLEAR]: {
    description: "User cleared auto area filter",
    eventType: EventType.INTERACTION,
    id: FormsEventKeys.AUTO_AREA_FILTER_CLEAR,
  },
  [FormsEventKeys.AUTO_AREA_FILTER_DISMISS]: {
    description: "User dismissed auto area filter",
    eventType: EventType.INTERACTION,
    id: FormsEventKeys.AUTO_AREA_FILTER_DISMISS,
  },
  [FormsEventKeys.SERVICE_AREA_SELECT]: {
    description: "User selected a service area",
    eventType: EventType.INTERACTION,
    id: FormsEventKeys.SERVICE_AREA_SELECT,
  },
  [FormsEventKeys.SERVICE_AREA_DESELECT]: {
    description: "User deselected a service area",
    eventType: EventType.INTERACTION,
    id: FormsEventKeys.SERVICE_AREA_DESELECT,
  },
  [FormsEventKeys.SERVICE_AREA_SELECT_STATE]: {
    description: "User selected all service areas in a state",
    eventType: EventType.INTERACTION,
    id: FormsEventKeys.SERVICE_AREA_SELECT_STATE,
  },
  [FormsEventKeys.SERVICE_AREA_DESELECT_STATE]: {
    description: "User deselected all service areas in a state",
    eventType: EventType.INTERACTION,
    id: FormsEventKeys.SERVICE_AREA_DESELECT_STATE,
  },
  [FormsEventKeys.SERVICE_AREA_CLEAR_STATE]: {
    description: "User cleared all service area selections",
    eventType: EventType.INTERACTION,
    id: FormsEventKeys.SERVICE_AREA_CLEAR_STATE,
  },
  [FormsEventKeys.SERVICE_AREA_SEARCH]: {
    description: "User searched for service areas",
    eventType: EventType.FILTER,
    id: FormsEventKeys.SERVICE_AREA_SEARCH,
  },
  [FormsEventKeys.TAG_SELECTOR_SELECT]: {
    description: "User selected a tag in TagSelector",
    eventType: EventType.INTERACTION,
    id: FormsEventKeys.TAG_SELECTOR_SELECT,
  },
  [FormsEventKeys.TAG_SELECTOR_DESELECT]: {
    description: "User deselected a tag in TagSelector",
    eventType: EventType.INTERACTION,
    id: FormsEventKeys.TAG_SELECTOR_DESELECT,
  },
  [FormsEventKeys.TAG_SELECTOR_SELECT_ALL_ACTIVE]: {
    description: "User selected all active tags in TagSelector",
    eventType: EventType.INTERACTION,
    id: FormsEventKeys.TAG_SELECTOR_SELECT_ALL_ACTIVE,
  },
  [FormsEventKeys.TAG_SELECTOR_CLEAR]: {
    description: "User cleared all tag selections in TagSelector",
    eventType: EventType.INTERACTION,
    id: FormsEventKeys.TAG_SELECTOR_CLEAR,
  },
  [FormsEventKeys.TAG_SELECTOR_SEARCH]: {
    description: "User searched for tags in TagSelector",
    eventType: EventType.FILTER,
    id: FormsEventKeys.TAG_SELECTOR_SEARCH,
  },
  [FormsEventKeys.ACTIONS_DROPDOWN_ACTION_SELECT]: {
    description: "User selected an action from the actions dropdown",
    eventType: EventType.INTERACTION,
    id: FormsEventKeys.ACTIONS_DROPDOWN_ACTION_SELECT,
  },
  [FormsEventKeys.CLEAR_FILTERS_BUTTON_CLICK]: {
    description: "User clicked the clear filters button",
    eventType: EventType.BUTTON_CLICK,
    id: FormsEventKeys.CLEAR_FILTERS_BUTTON_CLICK,
  },
  [FormsEventKeys.EMPTY_STATE_ACTION_BUTTON_CLICK]: {
    description: "User clicked an action button in empty state",
    eventType: EventType.BUTTON_CLICK,
    id: FormsEventKeys.EMPTY_STATE_ACTION_BUTTON_CLICK,
  },
  [FormsEventKeys.ERROR_CARD_BROWSE_OTHER_NEEDS_CLICK]: {
    description: "User clicked browse other needs in error card",
    eventType: EventType.BUTTON_CLICK,
    id: FormsEventKeys.ERROR_CARD_BROWSE_OTHER_NEEDS_CLICK,
  },
  [FormsEventKeys.CLAIM_DETAILS_BACK_TO_NEEDS_CLICK]: {
    description: "User clicked back to needs in claim details",
    eventType: EventType.BUTTON_CLICK,
    id: FormsEventKeys.CLAIM_DETAILS_BACK_TO_NEEDS_CLICK,
  },
  [FormsEventKeys.CLAIM_DETAILS_CONTACT_CASEWORKER_CLICK]: {
    description: "User clicked contact caseworker in claim details",
    eventType: EventType.BUTTON_CLICK,
    id: FormsEventKeys.CLAIM_DETAILS_CONTACT_CASEWORKER_CLICK,
  },
  [FormsEventKeys.DELETE_AREA_MODAL_OPEN]: {
    description: "User opened the delete area modal",
    eventType: EventType.INTERACTION,
    id: FormsEventKeys.DELETE_AREA_MODAL_OPEN,
  },
  [FormsEventKeys.DELETE_AREA_ATTEMPT]: {
    description: "User attempted to delete an area",
    eventType: EventType.INTERACTION,
    id: FormsEventKeys.DELETE_AREA_ATTEMPT,
  },
  [FormsEventKeys.DELETE_AREA_CANCEL]: {
    description: "User canceled area deletion",
    eventType: EventType.INTERACTION,
    id: FormsEventKeys.DELETE_AREA_CANCEL,
  },
  [FormsEventKeys.DELETE_AREA_SUCCESS]: {
    description: "User successfully deleted an area",
    eventType: EventType.INTERACTION,
    id: FormsEventKeys.DELETE_AREA_SUCCESS,
  },
  [FormsEventKeys.DELETE_AREA_FAILURE]: {
    description: "User failed to delete an area",
    eventType: EventType.ERROR,
    id: FormsEventKeys.DELETE_AREA_FAILURE,
  },
  [FormsEventKeys.DELETE_CATEGORY_ATTEMPT]: {
    description: "User attempted to delete a category",
    eventType: EventType.INTERACTION,
    id: FormsEventKeys.DELETE_CATEGORY_ATTEMPT,
  },
  [FormsEventKeys.DELETE_CATEGORY_SUCCESS]: {
    description: "User successfully deleted a category",
    eventType: EventType.INTERACTION,
    id: FormsEventKeys.DELETE_CATEGORY_SUCCESS,
  },
  [FormsEventKeys.DELETE_CATEGORY_FAILURE]: {
    description: "User failed to delete a category",
    eventType: EventType.ERROR,
    id: FormsEventKeys.DELETE_CATEGORY_FAILURE,
  },
  [FormsEventKeys.PURCHASE_LINKS_ADD]: {
    description: "User added a purchase link",
    eventType: EventType.INTERACTION,
    id: FormsEventKeys.PURCHASE_LINKS_ADD,
  },
  [FormsEventKeys.PURCHASE_LINKS_REMOVE]: {
    description: "User removed a purchase link",
    eventType: EventType.INTERACTION,
    id: FormsEventKeys.PURCHASE_LINKS_REMOVE,
  },
  [FormsEventKeys.STOCK_PHOTO_MODAL_CATEGORY_SELECT]: {
    description: "User selected a category in stock photo modal",
    eventType: EventType.INTERACTION,
    id: FormsEventKeys.STOCK_PHOTO_MODAL_CATEGORY_SELECT,
  },
  [FormsEventKeys.STOCK_PHOTO_MODAL_PHOTO_SELECT]: {
    description: "User selected a photo in stock photo modal",
    eventType: EventType.INTERACTION,
    id: FormsEventKeys.STOCK_PHOTO_MODAL_PHOTO_SELECT,
  },
  [FormsEventKeys.STOCK_PHOTO_MODAL_CONFIRM]: {
    description: "User confirmed photo selection in stock photo modal",
    eventType: EventType.INTERACTION,
    id: FormsEventKeys.STOCK_PHOTO_MODAL_CONFIRM,
  },
  [FormsEventKeys.STOCK_PHOTO_MODAL_CLOSE]: {
    description: "User closed the stock photo modal",
    eventType: EventType.INTERACTION,
    id: FormsEventKeys.STOCK_PHOTO_MODAL_CLOSE,
  },
  [FormsEventKeys.SETTINGS_COMPLETION_TRACKER_ITEM_CLICK]: {
    description: "User clicked an item in settings completion tracker",
    eventType: EventType.BUTTON_CLICK,
    id: FormsEventKeys.TUTORIAL_ERROR_BOUNDARY_ERROR,
  },
  [FormsEventKeys.TUTORIAL_ERROR_BOUNDARY_ERROR]: {
    description: "An error occurred in tutorial error boundary",
    eventType: EventType.ERROR,
    id: FormsEventKeys.TUTORIAL_LAUNCHER_OPEN,
  },
  [FormsEventKeys.TUTORIAL_LAUNCHER_OPEN]: {
    description: "User opened the tutorial launcher",
    eventType: EventType.INTERACTION,
    id: FormsEventKeys.TUTORIAL_LAUNCHER_CLOSE,
  },
  [FormsEventKeys.TUTORIAL_LAUNCHER_CLOSE]: {
    description: "User closed the tutorial launcher",
    eventType: EventType.INTERACTION,
    id: FormsEventKeys.TUTORIAL_LAUNCHER_START,
  },
  [FormsEventKeys.TUTORIAL_LAUNCHER_START]: {
    description: "User started a tutorial from the launcher",
    eventType: EventType.INTERACTION,
    id: FormsEventKeys.TUTORIAL_PROVIDER_START,
  },
  [FormsEventKeys.TUTORIAL_PROVIDER_START]: {
    description: "Tutorial provider started",
    eventType: EventType.INTERACTION,
    id: FormsEventKeys.TUTORIAL_PROVIDER_COMPLETE,
  },
  [FormsEventKeys.TUTORIAL_PROVIDER_COMPLETE]: {
    description: "Tutorial provider completed",
    eventType: EventType.INTERACTION,
    id: FormsEventKeys.TUTORIAL_PROVIDER_SKIP,
  },
  [FormsEventKeys.TUTORIAL_PROVIDER_SKIP]: {
    description: "User skipped tutorial provider",
    eventType: EventType.INTERACTION,
    id: FormsEventKeys.TUTORIAL_PROVIDER_ERROR,
  },
  [FormsEventKeys.TUTORIAL_PROVIDER_ERROR]: {
    description: "An error occurred in tutorial provider",
    eventType: EventType.ERROR,
    id: FormsEventKeys.TUTORIAL_OVERLAY_NEXT_STEP,
  },
  [FormsEventKeys.TUTORIAL_OVERLAY_NEXT_STEP]: {
    description: "User moved to next step in tutorial overlay",
    eventType: EventType.INTERACTION,
    id: FormsEventKeys.TUTORIAL_OVERLAY_PREVIOUS_STEP,
  },
  [FormsEventKeys.TUTORIAL_OVERLAY_PREVIOUS_STEP]: {
    description: "User moved to previous step in tutorial overlay",
    eventType: EventType.INTERACTION,
    id: FormsEventKeys.TUTORIAL_OVERLAY_COMPLETE_STEP,
  },
  [FormsEventKeys.TUTORIAL_OVERLAY_COMPLETE_STEP]: {
    description: "User completed a step in tutorial overlay",
    eventType: EventType.INTERACTION,
    id: FormsEventKeys.TUTORIAL_OVERLAY_FINISH,
  },
  [FormsEventKeys.TUTORIAL_OVERLAY_FINISH]: {
    description: "User finished tutorial overlay",
    eventType: EventType.INTERACTION,
    id: FormsEventKeys.TUTORIAL_OVERLAY_SKIP,
  },
  [FormsEventKeys.TUTORIAL_OVERLAY_SKIP]: {
    description: "User skipped tutorial overlay",
    eventType: EventType.INTERACTION,
    id: FormsEventKeys.VOLUNTEER_ENGAGEMENT_EXPORT,
  },
  [FormsEventKeys.VOLUNTEER_ENGAGEMENT_EXPORT]: {
    description: "User exported volunteer engagement data",
    eventType: EventType.INTERACTION,
    id: FormsEventKeys.VOLUNTEER_ENGAGEMENT_REFRESH,
  },
  [FormsEventKeys.VOLUNTEER_ENGAGEMENT_REFRESH]: {
    description: "User refreshed volunteer engagement data",
    eventType: EventType.INTERACTION,
    id: FormsEventKeys.VOLUNTEER_SIGNUP_OFFER_SIGNUP_CLICK,
  },
  [FormsEventKeys.VOLUNTEER_SIGNUP_OFFER_SIGNUP_CLICK]: {
    description: "User clicked signup in volunteer signup offer",
    eventType: EventType.BUTTON_CLICK,
    id: FormsEventKeys.VOLUNTEER_SIGNUP_OFFER_DECLINE_CLICK,
  },
  [FormsEventKeys.VOLUNTEER_SIGNUP_OFFER_DECLINE_CLICK]: {
    description: "User clicked decline in volunteer signup offer",
    eventType: EventType.BUTTON_CLICK,
    id: FormsEventKeys.VOLUNTEER_SIGNUP_OFFER_DECLINE_CLICK,
  },
};
